import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // 剧集分享
  {
    path: "/vod",
    component: function(resolve) {
      require(["../views/vod.vue"], resolve);
    }
  },
  // 下载 QR
  {
    path: "/download",
    component: function(resolve) {
      require(["../views/download.vue"], resolve);
    }
  }
];

if (process.env.VUE_APP_ENV === "sit" || process.env.VUE_APP_ENV === "dev") {
  let testRouters = [
    // 剧集分享测试
    {
      path: "/test",
      component: function(resolve) {
        require(["../views/test.vue"], resolve);
      }
    },
    {
      path: "/testtwo",
      component: function(resolve) {
        require(["../views/testtwo.vue"], resolve);
      }
    }
  ];
  routes.push(...testRouters);
}

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes
});

//修改title
router.afterEach(to => {
  let title = to.meta.title;
  if (!!title) {
    document.title = title;
  }
});

export default router;
